
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PhoenixGRTDCADynamicContentV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxRequested"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slotsAvailable"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DCADynamicContentV2Input"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dynamicContentByMboxes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mboxes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"maxRequested"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxRequested"}}},{"kind":"Argument","name":{"kind":"Name","value":"slotsAvailable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slotsAvailable"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eVar48"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressionValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analyticsName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metaTags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionMedium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descriptionShort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"destinationUrl1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"destinationUrl2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eyebrowText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerMedium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headerShort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternateDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageSrc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wideHorizontal"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localeOfContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mboxName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responseTokens"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":708}};
    doc.loc.source = {"body":"query PhoenixGRTDCADynamicContentV2($maxRequested: Int, $slotsAvailable: Int, $input: DCADynamicContentV2Input!) {\n  dynamicContentByMboxes(input: $input) {\n    mboxes {\n      adData(maxRequested: $maxRequested, slotsAvailable: $slotsAvailable)\n      eVar48\n      impressionValue\n      analyticsName\n      metaTags\n      descriptionLong\n      descriptionMedium\n      descriptionShort\n      destinationUrl1\n      destinationUrl2\n      eyebrowText\n      headerLong\n      headerMedium\n      headerShort\n      image {\n        alternateDescription\n        imageSrc\n        imageUrls {\n          wideHorizontal\n        }\n      }\n      localeOfContent\n      mboxName\n      metadata\n      responseTokens\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PhoenixGRTDCADynamicContentV2"] = oneQuery(doc, "PhoenixGRTDCADynamicContentV2");
        
